export default __webpack_public_path__ + "media/tests/test_zyvo-3e26f4d6.png";